import { useNavigate } from "react-router-dom";
import { Logo } from "src/components/Logo";
import { Footer } from "../LoginPage/Footer";
import { Button } from "@porchpass/ui";

const EmailSentPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-between items-center min-h-screen bg-surface-muted">
      <div className="flex flex-col items-center w-full">
        <div className="mt-20">
          <Logo />
        </div>

        <div className="flex flex-col items-center mx-auto mt-[200px] w-[410px]">
          <div className="flex flex-col gap-4 items-center mb-8 w-full">
            <div className="flex gap-1 items-center">
              <h1 className="text-[28px] font-semibold leading-[32px] text-on-surface-primary text-center">
                Password reset
              </h1>
              <h1 className="text-[28px] font-semibold leading-[32px] text-on-surface-primary text-center">
                email
              </h1>
              <div className="bg-[#e5ebfd] rounded-[24px] px-1.5 py-1 flex items-center">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M2 6L9 11L16 6"
                    stroke="#1453f5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <rect
                    x="2"
                    y="4"
                    width="14"
                    height="10"
                    rx="1"
                    stroke="#1453f5"
                    strokeWidth="1.5"
                  />
                </svg>
              </div>
              <h1 className="text-[28px] font-semibold leading-[32px] text-on-surface-primary text-center">
                sent
              </h1>
            </div>
            <p className="text-[13px] font-normal leading-[17px] text-on-surface-muted text-center">
              Please check your inbox for further instructions.
            </p>
          </div>

          <Button
            variant="ghost-blue"
            size="m"
            onClick={() => {
              void navigate("/login");
            }}
            className="w-full"
          >
            <div className="flex gap-2 items-center">
              <svg
                width="14"
                height="11"
                viewBox="0 0 14 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 0.5625C5.25 0.25184 5.50184 0 5.8125 0H9.1875C11.3621 0 13.125 1.76288 13.125 3.9375C13.125 6.11212 11.3621 7.875 9.1875 7.875H1.65958C1.7831 7.99323 1.91784 8.1149 2.05628 8.2351C2.3277 8.47076 2.60078 8.68993 2.807 8.85087C2.90982 8.93111 2.99533 8.99634 3.05484 9.04128C3.08458 9.06375 3.14381 9.10808 3.15939 9.11969C3.40949 9.30393 3.44963 9.64594 3.26542 9.89607C3.0812 10.1462 2.72897 10.1996 2.47883 10.0153L2.47827 10.0149C2.46033 10.0016 2.40825 9.96275 2.3768 9.93899C2.31326 9.891 2.22299 9.82214 2.11487 9.73776C1.89922 9.56947 1.60979 9.33731 1.31872 9.08459C1.03044 8.83429 0.727661 8.55276 0.492533 8.28665C0.375538 8.15424 0.26339 8.01239 0.177444 7.86982C0.100805 7.74269 -1.9669e-06 7.54327 0 7.3125C0 7.08173 0.100809 6.8823 0.177448 6.75518C0.263395 6.61261 0.375542 6.47076 0.492538 6.33835C0.727665 6.07224 1.03044 5.79071 1.31872 5.54041C1.6098 5.28769 1.89922 5.05553 2.11487 4.88724C2.22299 4.80286 2.31326 4.734 2.3768 4.68601C2.40779 4.6626 2.45883 4.62456 2.47746 4.61067L2.47784 4.61039L2.47883 4.60965C2.72897 4.42543 3.0812 4.47879 3.26542 4.72893C3.4451 4.97289 3.39871 5.31386 3.16425 5.50146L3.05484 5.58372C2.99533 5.62866 2.90982 5.69389 2.807 5.77413C2.60078 5.93507 2.32771 6.15424 2.05628 6.3899C1.91785 6.5101 1.78311 6.63177 1.65958 6.75H9.1875C10.7408 6.75 12 5.4908 12 3.9375C12 2.3842 10.7408 1.125 9.1875 1.125H5.8125C5.50184 1.125 5.25 0.87316 5.25 0.5625Z"
                  fill="currentColor"
                />
              </svg>
              <span>Back to sign in</span>
            </div>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EmailSentPage;
